import React from 'react';
import CryptoWallet from '../CryptoWallet/CryptoWallet';
import Cancellable from '../../Cancellable/Cancellable';

export default class CryptoWalletsList extends Cancellable {
  render() {
    const { coins, wallets, onWalletCreated, onAddressClick } = this.props;

    return (
      <div className="crypto-wallets-list">
        {coins.map((coin) => (
          <CryptoWallet
            key={coin.id}
            id={coin.id}
            name={coin.name}
            address={wallets[coin.id] ? wallets[coin.id].address : undefined}
            onWalletCreated={onWalletCreated}
            onAddressClick={onAddressClick}
          />
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Crypto/CryptoWalletsList/CryptoWalletsList.jsx